import { useState } from 'react';
import SingleClassBlock from '~/components/forms/questions/scheduling/SingleClassBlock.jsx';
import ClassViewModal from '~/components/forms/questions/scheduling/ClassViewModal.jsx';
import { FormPart, part } from '~/lib/FormCssApi';

const CardClassList = ({
    classes,
    settings,
    selectedClasses,
    onSelectClass,
    onRemoveClass,
    clientTz,
}) => {
    const [viewingClass, setViewingClass] = useState(null);

    return (
        <>
            <div
                {...part(FormPart.CLASS_LIST)}
                className="grid grid-cols-1 xs:grid-cols-2 sm:flex sm:flex-wrap gap-4"
            >
                {classes.map(instance => (
                    <div
                        key={instance.id}
                        className="w-full sm:w-[225px]"
                    >
                        <SingleClassBlock
                            instance={instance}
                            onClick={() => setViewingClass(instance)}
                            settings={settings}
                            selectedClasses={selectedClasses}
                            clientTz={clientTz}
                            showDate={true}
                            isLarge={true}
                        />
                    </div>
                ))}
            </div>

            <ClassViewModal
                isOpen={!!viewingClass}
                instance={viewingClass}
                onClose={() => setViewingClass(null)}
                onSelect={onSelectClass}
                onRemoveClass={onRemoveClass}
                selectedClasses={selectedClasses}
                settings={settings}
                clientTz={clientTz}
            />
        </>
    );
};

export default CardClassList;
